import {Component, EventEmitter, Input, Output} from '@angular/core';
import {selectCanViewSegmentAuditLogs, selectCanViewValidations} from '../../user/user.reducer';
import {SegmentValidationModel} from './validation/validation.model';
import {selectSegmentValidations} from './validation/validation.reducer';
import {closeSegmentDetailsAndClearSelection, SegmentWithAccount, selectSegmentDetails} from '../segments.state';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {SegmentListConfig} from '../segment-config.model';
import {ApiVersion} from '../../app.types';

@Component({
  selector: 'app-segment-info',
  template: `
    <div id="sitebar-info"
         data-cy="element-sidebar-info">
      <div class="page-header" id="segment-info-controls">
        <div style="flex:1">
          <button (click)="close()" id="close-sidebar" mat-icon-button name="close-sidebar">
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
        <div>
          <app-segment-edit-button
            [apiVersion]="apiVersion"
            *ngIf="config.segmentDetailsButtonsToPresent.includes('edit')"></app-segment-edit-button>
          <app-segment-delete-button *ngIf="config.segmentDetailsButtonsToPresent.includes('delete')"
                                     (deleteEmitter)="deleteSegment()"></app-segment-delete-button>
        </div>
      </div>

      <ng-container *ngIf="selectedSegment$ | async as segmentWithAccount; else spinner">
        <div id="segment-info-header" class="mat-body-1">
            <span class="name"
                  id="segment-info-name"
                  data-cy="element-segment-info-name"><strong>{{segmentWithAccount.segment?.name}}</strong></span><br/>
          ID: <span
          class="name">{{segmentWithAccount.segment?.id}} {{segmentWithAccount.segment?.clientSideId}}</span><br/>
          Description: <span class="description" id="segment-info-description">{{segmentWithAccount.segment?.description}}</span><br/>
          Category: <span class="name">{{segmentWithAccount.segment?.category}}</span><br/>
          Main Type: <span class="name">{{segmentWithAccount.segment?.mainType}}</span><br/>
          Sub Type: <span class="name">{{segmentWithAccount.segment?.subType}}</span><br/>
          Audience Type: <span class="name">{{segmentWithAccount.segment?.audienceType}}</span>
        </div>

        <mat-tab-group dynamicHeight="true"
                       id="segment-info-tab-group"
                       data-cy="element-segment-info-tabs">

          <mat-tab *ngIf="config.segmentDetailsTabsToPresent.includes('accounts')" label="Target Systems"
                   data-cy="element-segment-info-tab">
            <app-segment-info-account-list [selectedSegment]="segmentWithAccount"></app-segment-info-account-list>
          </mat-tab>

          <mat-tab *ngIf="(viewValidationsRole$ | async) && config.segmentDetailsTabsToPresent.includes('validations')"
                   data-cy="element-segment-info-tab">
            <ng-template mat-tab-label>
              <div style="position:relative">
                Validations
                <span
                  *ngIf="segmentWithAccount.segment?.sharedAccounts && (segmentValidations$ | async)?.length as segVal"
                  class="counter-bubble">{{segVal}}</span>
              </div>
            </ng-template>
            <app-segment-validation></app-segment-validation>
          </mat-tab>

          <mat-tab #matTab *ngIf="(viewAuditLogsRole$ | async) && config.segmentDetailsTabsToPresent.includes('auditLogs')"
                   data-cy="element-segment-info-tab" label="Audit logs">
            <app-segment-audit-logs *ngIf="matTab.isActive"></app-segment-audit-logs>
          </mat-tab>
        </mat-tab-group>
      </ng-container>

      <ng-template #spinner>
        <mat-spinner mode="indeterminate"></mat-spinner>
      </ng-template>
    </div>
  `,
  styleUrls: ['info.component.scss']
})
export class SegmentInfoComponent {
  @Output() showDeleteSegmentDialog = new EventEmitter<number>();
  @Input() config!: SegmentListConfig;
  @Input() apiVersion: ApiVersion = ApiVersion.V1;
  selectedSegment$: Observable<SegmentWithAccount | undefined> = this.store.select(selectSegmentDetails);
  segmentValidations$: Observable<SegmentValidationModel[]> = this.store.select(selectSegmentValidations);
  viewValidationsRole$: Observable<boolean> = this.store.select(selectCanViewValidations);
  viewAuditLogsRole$: Observable<boolean> = this.store.select(selectCanViewSegmentAuditLogs);

  constructor(private store: Store) {
  }

  deleteSegment() {
    this.showDeleteSegmentDialog.emit();
  }

  close() {
    this.store.dispatch(closeSegmentDetailsAndClearSelection());
  }
}
